import { conferences } from "./brands/conferences.theme.js";
import { ida } from "./brands/ida.theme.js";
import { insurance } from "./brands/insurance.theme.js";
import { student } from "./brands/student.theme.js";
const themes = { conferences, insurance, ida, student };
export {
  themes
};
